import { Link } from 'react-router-dom';

interface BreadcrumbsProps {
  title: string;
}

export default function Breadcrumbs({ title }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center gap-2 text-xs text-gray-500 flex-wrap">
        <li>
          <a href="https://masonhalefit.com" className="hover:text-[#c8a96e] transition-colors">
            Home
          </a>
        </li>
        <li className="text-gray-600">
          <i className="ri-arrow-right-s-line" aria-hidden="true" />
        </li>
        <li>
          <Link to="/blog" className="hover:text-[#c8a96e] transition-colors">
            Blog
          </Link>
        </li>
        <li className="text-gray-600">
          <i className="ri-arrow-right-s-line" aria-hidden="true" />
        </li>
        <li className="text-gray-400 truncate max-w-[200px] sm:max-w-none">{title}</li>
      </ol>
    </nav>
  );
}
